module.exports = __webpack_public_path__ + "static/media/Compras8.1abc30be.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/LancCompras/Compras8.png
// module id = 2074
// module chunks = 0